import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./metaPixel";

/**
 * Sends one PageView for the initial page and one for every route change.
 * Effects run after the router has updated the address bar, so the pixel reports the new URL.
 */
export function useMetaPixelPageView() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    trackPageView(pathname + search);
  }, [pathname, search]);
}
